module.exports = "pegasus/assets/themelp1/health/101.png";